function clean(value) {
  return String(value || "").trim();
}

export function presentDependantIdentityStatus(status) {
  const normalized = clean(status).toLowerCase();
  if (normalized === "verified") return "verified";
  if (normalized === "needs_resubmission") return "needs_resubmission";
  if (normalized === "document_reviewed") return "document_reviewed";
  // These are materially different states.  A dependant must not appear to
  // have a document in review until there is a bound owner submission.
  if (normalized === "pending_review") return "pending_review";
  if (normalized === "pending_upload") return "pending_upload";
  return "pending_upload";
}

export async function hydrateDependantIdentityStatuses(supabase, rows = []) {
  const list = Array.isArray(rows) ? rows : [];
  const dependantIds = [...new Set(list.map((row) => clean(row?.id)).filter(Boolean))];
  if (!dependantIds.length) return list;

  const { data, error } = await supabase
    .from("dependant_identity_verifications")
    .select("dependant_id,status,reviewer_user_id,reviewed_at,created_at,provenance_state")
    .in("dependant_id", dependantIds)
    .order("created_at", { ascending: false });

  // A missing table/column, policy denial or transient read error must not
  // resurrect a legacy per-dependant status from patient_dependants. The only
  // evidence accepted by this surface is a bound, non-quarantined ledger row.
  if (error) {
    return list.map((row) => ({
      ...row,
      identity_verification_status: "pending_upload",
      identity_verification: null,
    }));
  }
  const latest = new Map();
  for (const verification of Array.isArray(data) ? data : []) {
    const dependantId = clean(verification?.dependant_id);
    // Quarantined legacy links are retained for authorised investigation, but
    // are never evidence of this dependant's identity verification.
    if (clean(verification?.provenance_state).toLowerCase() === "quarantined") continue;
    if (dependantId && !latest.has(dependantId)) latest.set(dependantId, verification);
  }

  return list.map((row) => {
    const verification = latest.get(clean(row?.id));
    return {
      ...row,
      identity_verification_status: presentDependantIdentityStatus(verification?.status),
      identity_verification: verification || null,
    };
  });
}
